
<div class="component-container">

<div class="forgot-password-container">
    <h1>Forgot Password</h1>
    <p class="description">Enter your email address and we'll send you a link to reset your password.</p>
    
    <div class="success-message" id="successMessage" [style.display]="emailSent ? 'block' : 'none'">
        Password reset link sent! Please check your email.
    </div>
    
    <form id="forgotPasswordForm">
        <div class="form-group">
            <label for="email">Email</label>
            <input type="email" name="email" placeholder="Enter your email address" [(ngModel)]="email" required>
        </div>
        <button type="submit" class="btn" (click)="sendResetLink()" [disabled]="email.length === 0">Reset Password</button>
        <p class="login-link">Remember your password? <a [routerLink]="['/']" (click)="loginDialog()">Back to Login</a></p>
    </form>
</div>
</div>
